/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as protectedRouteRouteImport } from './routes/(protected)/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as protectedManagementRouteRouteImport } from './routes/(protected)/management/route'
import { Route as protectedStaffIndexRouteImport } from './routes/(protected)/staff/index'
import { Route as protectedSchedulesIndexRouteImport } from './routes/(protected)/schedules/index'
import { Route as protectedRoomsIndexRouteImport } from './routes/(protected)/rooms/index'
import { Route as protectedRankingIndexRouteImport } from './routes/(protected)/ranking/index'
import { Route as protectedProfileIndexRouteImport } from './routes/(protected)/profile/index'
import { Route as protectedManagementIndexRouteImport } from './routes/(protected)/management/index'
import { Route as protectedExercisesIndexRouteImport } from './routes/(protected)/exercises/index'
import { Route as protectedDisciplinesIndexRouteImport } from './routes/(protected)/disciplines/index'
import { Route as protectedDashboardIndexRouteImport } from './routes/(protected)/dashboard/index'
import { Route as protectedChallengesIndexRouteImport } from './routes/(protected)/challenges/index'
import { Route as protectedAthletesIndexRouteImport } from './routes/(protected)/athletes/index'
import { Route as protectedAllocationIndexRouteImport } from './routes/(protected)/allocation/index'
import { Route as authSignInIndexRouteImport } from './routes/(auth)/sign-in/index'
import { Route as authResetPasswordIndexRouteImport } from './routes/(auth)/reset-password/index'
import { Route as authForgotPasswordIndexRouteImport } from './routes/(auth)/forgot-password/index'
import { Route as protectedStaffNewIndexRouteImport } from './routes/(protected)/staff/new/index'
import { Route as protectedStaffStaffMemberIdIndexRouteImport } from './routes/(protected)/staff/$staffMemberId/index'
import { Route as protectedRoomsNewIndexRouteImport } from './routes/(protected)/rooms/new/index'
import { Route as protectedRoomsRoomIdIndexRouteImport } from './routes/(protected)/rooms/$roomId/index'
import { Route as protectedManagementExercisesIndexRouteImport } from './routes/(protected)/management/exercises/index'
import { Route as protectedManagementDisciplinesIndexRouteImport } from './routes/(protected)/management/disciplines/index'
import { Route as protectedManagementDashboardIndexRouteImport } from './routes/(protected)/management/dashboard/index'
import { Route as protectedAthletesNewIndexRouteImport } from './routes/(protected)/athletes/new/index'
import { Route as protectedAthletesAthleteIdIndexRouteImport } from './routes/(protected)/athletes/$athleteId/index'
import { Route as protectedAllocationEventIdIndexRouteImport } from './routes/(protected)/allocation/$eventId/index'
import { Route as protectedStaffStaffMemberIdEditIndexRouteImport } from './routes/(protected)/staff/$staffMemberId/edit/index'
import { Route as protectedSchedulesScheduleIdEditIndexRouteImport } from './routes/(protected)/schedules/$scheduleId/edit/index'
import { Route as protectedManagementExercisesNewIndexRouteImport } from './routes/(protected)/management/exercises/new/index'
import { Route as protectedManagementExercisesExerciseIdIndexRouteImport } from './routes/(protected)/management/exercises/$exerciseId/index'
import { Route as protectedManagementDisciplinesNewIndexRouteImport } from './routes/(protected)/management/disciplines/new/index'
import { Route as protectedManagementDisciplinesDisciplineIdIndexRouteImport } from './routes/(protected)/management/disciplines/$disciplineId/index'
import { Route as protectedAthletesAthleteIdEditIndexRouteImport } from './routes/(protected)/athletes/$athleteId/edit/index'
import { Route as protectedAllocationEventsNewIndexRouteImport } from './routes/(protected)/allocation/events/new/index'
import { Route as protectedAllocationEventIdEditIndexRouteImport } from './routes/(protected)/allocation/$eventId/edit/index'
import { Route as protectedAthletesAthleteIdWorkoutPlansNewIndexRouteImport } from './routes/(protected)/athletes/$athleteId/workout-plans/new/index'
import { Route as protectedAthletesAthleteIdWorkoutBlocksNewIndexRouteImport } from './routes/(protected)/athletes/$athleteId/workout-blocks/new/index'
import { Route as protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRouteImport } from './routes/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/index'
import { Route as protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRouteImport } from './routes/(protected)/athletes/$athleteId/workout-plans/$workoutPlanId/edit/index'
import { Route as protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRouteImport } from './routes/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/index'

const protectedRouteRoute = protectedRouteRouteImport.update({
  id: '/(protected)',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedManagementRouteRoute =
  protectedManagementRouteRouteImport.update({
    id: '/management',
    path: '/management',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedStaffIndexRoute = protectedStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedSchedulesIndexRoute = protectedSchedulesIndexRouteImport.update({
  id: '/schedules/',
  path: '/schedules/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedRoomsIndexRoute = protectedRoomsIndexRouteImport.update({
  id: '/rooms/',
  path: '/rooms/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedRankingIndexRoute = protectedRankingIndexRouteImport.update({
  id: '/ranking/',
  path: '/ranking/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedProfileIndexRoute = protectedProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedManagementIndexRoute =
  protectedManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedExercisesIndexRoute = protectedExercisesIndexRouteImport.update({
  id: '/exercises/',
  path: '/exercises/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedDisciplinesIndexRoute =
  protectedDisciplinesIndexRouteImport.update({
    id: '/disciplines/',
    path: '/disciplines/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedDashboardIndexRoute = protectedDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedChallengesIndexRoute =
  protectedChallengesIndexRouteImport.update({
    id: '/challenges/',
    path: '/challenges/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesIndexRoute = protectedAthletesIndexRouteImport.update({
  id: '/athletes/',
  path: '/athletes/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedAllocationIndexRoute =
  protectedAllocationIndexRouteImport.update({
    id: '/allocation/',
    path: '/allocation/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const authSignInIndexRoute = authSignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => authRouteRoute,
} as any)
const authResetPasswordIndexRoute = authResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => authRouteRoute,
} as any)
const authForgotPasswordIndexRoute = authForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => authRouteRoute,
} as any)
const protectedStaffNewIndexRoute = protectedStaffNewIndexRouteImport.update({
  id: '/staff/new/',
  path: '/staff/new/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedStaffStaffMemberIdIndexRoute =
  protectedStaffStaffMemberIdIndexRouteImport.update({
    id: '/staff/$staffMemberId/',
    path: '/staff/$staffMemberId/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedRoomsNewIndexRoute = protectedRoomsNewIndexRouteImport.update({
  id: '/rooms/new/',
  path: '/rooms/new/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedRoomsRoomIdIndexRoute =
  protectedRoomsRoomIdIndexRouteImport.update({
    id: '/rooms/$roomId/',
    path: '/rooms/$roomId/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedManagementExercisesIndexRoute =
  protectedManagementExercisesIndexRouteImport.update({
    id: '/exercises/',
    path: '/exercises/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedManagementDisciplinesIndexRoute =
  protectedManagementDisciplinesIndexRouteImport.update({
    id: '/disciplines/',
    path: '/disciplines/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedManagementDashboardIndexRoute =
  protectedManagementDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedAthletesNewIndexRoute =
  protectedAthletesNewIndexRouteImport.update({
    id: '/athletes/new/',
    path: '/athletes/new/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesAthleteIdIndexRoute =
  protectedAthletesAthleteIdIndexRouteImport.update({
    id: '/athletes/$athleteId/',
    path: '/athletes/$athleteId/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAllocationEventIdIndexRoute =
  protectedAllocationEventIdIndexRouteImport.update({
    id: '/allocation/$eventId/',
    path: '/allocation/$eventId/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedStaffStaffMemberIdEditIndexRoute =
  protectedStaffStaffMemberIdEditIndexRouteImport.update({
    id: '/staff/$staffMemberId/edit/',
    path: '/staff/$staffMemberId/edit/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSchedulesScheduleIdEditIndexRoute =
  protectedSchedulesScheduleIdEditIndexRouteImport.update({
    id: '/schedules/$scheduleId/edit/',
    path: '/schedules/$scheduleId/edit/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedManagementExercisesNewIndexRoute =
  protectedManagementExercisesNewIndexRouteImport.update({
    id: '/exercises/new/',
    path: '/exercises/new/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedManagementExercisesExerciseIdIndexRoute =
  protectedManagementExercisesExerciseIdIndexRouteImport.update({
    id: '/exercises/$exerciseId/',
    path: '/exercises/$exerciseId/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedManagementDisciplinesNewIndexRoute =
  protectedManagementDisciplinesNewIndexRouteImport.update({
    id: '/disciplines/new/',
    path: '/disciplines/new/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedManagementDisciplinesDisciplineIdIndexRoute =
  protectedManagementDisciplinesDisciplineIdIndexRouteImport.update({
    id: '/disciplines/$disciplineId/',
    path: '/disciplines/$disciplineId/',
    getParentRoute: () => protectedManagementRouteRoute,
  } as any)
const protectedAthletesAthleteIdEditIndexRoute =
  protectedAthletesAthleteIdEditIndexRouteImport.update({
    id: '/athletes/$athleteId/edit/',
    path: '/athletes/$athleteId/edit/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAllocationEventsNewIndexRoute =
  protectedAllocationEventsNewIndexRouteImport.update({
    id: '/allocation/events/new/',
    path: '/allocation/events/new/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAllocationEventIdEditIndexRoute =
  protectedAllocationEventIdEditIndexRouteImport.update({
    id: '/allocation/$eventId/edit/',
    path: '/allocation/$eventId/edit/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesAthleteIdWorkoutPlansNewIndexRoute =
  protectedAthletesAthleteIdWorkoutPlansNewIndexRouteImport.update({
    id: '/athletes/$athleteId/workout-plans/new/',
    path: '/athletes/$athleteId/workout-plans/new/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute =
  protectedAthletesAthleteIdWorkoutBlocksNewIndexRouteImport.update({
    id: '/athletes/$athleteId/workout-blocks/new/',
    path: '/athletes/$athleteId/workout-blocks/new/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute =
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRouteImport.update({
    id: '/athletes/$athleteId/workout-blocks/$workoutBlockId/',
    path: '/athletes/$athleteId/workout-blocks/$workoutBlockId/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute =
  protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRouteImport.update(
    {
      id: '/athletes/$athleteId/workout-plans/$workoutPlanId/edit/',
      path: '/athletes/$athleteId/workout-plans/$workoutPlanId/edit/',
      getParentRoute: () => protectedRouteRoute,
    } as any,
  )
const protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute =
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRouteImport.update(
    {
      id: '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/',
      path: '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/',
      getParentRoute: () => protectedRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof protectedRouteRouteWithChildren
  '/management': typeof protectedManagementRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordIndexRoute
  '/reset-password': typeof authResetPasswordIndexRoute
  '/sign-in': typeof authSignInIndexRoute
  '/allocation': typeof protectedAllocationIndexRoute
  '/athletes': typeof protectedAthletesIndexRoute
  '/challenges': typeof protectedChallengesIndexRoute
  '/dashboard': typeof protectedDashboardIndexRoute
  '/disciplines': typeof protectedDisciplinesIndexRoute
  '/exercises': typeof protectedExercisesIndexRoute
  '/management/': typeof protectedManagementIndexRoute
  '/profile': typeof protectedProfileIndexRoute
  '/ranking': typeof protectedRankingIndexRoute
  '/rooms': typeof protectedRoomsIndexRoute
  '/schedules': typeof protectedSchedulesIndexRoute
  '/staff': typeof protectedStaffIndexRoute
  '/allocation/$eventId': typeof protectedAllocationEventIdIndexRoute
  '/athletes/$athleteId': typeof protectedAthletesAthleteIdIndexRoute
  '/athletes/new': typeof protectedAthletesNewIndexRoute
  '/management/dashboard': typeof protectedManagementDashboardIndexRoute
  '/management/disciplines': typeof protectedManagementDisciplinesIndexRoute
  '/management/exercises': typeof protectedManagementExercisesIndexRoute
  '/rooms/$roomId': typeof protectedRoomsRoomIdIndexRoute
  '/rooms/new': typeof protectedRoomsNewIndexRoute
  '/staff/$staffMemberId': typeof protectedStaffStaffMemberIdIndexRoute
  '/staff/new': typeof protectedStaffNewIndexRoute
  '/allocation/$eventId/edit': typeof protectedAllocationEventIdEditIndexRoute
  '/allocation/events/new': typeof protectedAllocationEventsNewIndexRoute
  '/athletes/$athleteId/edit': typeof protectedAthletesAthleteIdEditIndexRoute
  '/management/disciplines/$disciplineId': typeof protectedManagementDisciplinesDisciplineIdIndexRoute
  '/management/disciplines/new': typeof protectedManagementDisciplinesNewIndexRoute
  '/management/exercises/$exerciseId': typeof protectedManagementExercisesExerciseIdIndexRoute
  '/management/exercises/new': typeof protectedManagementExercisesNewIndexRoute
  '/schedules/$scheduleId/edit': typeof protectedSchedulesScheduleIdEditIndexRoute
  '/staff/$staffMemberId/edit': typeof protectedStaffStaffMemberIdEditIndexRoute
  '/athletes/$athleteId/workout-blocks/$workoutBlockId': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute
  '/athletes/$athleteId/workout-blocks/new': typeof protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute
  '/athletes/$athleteId/workout-plans/new': typeof protectedAthletesAthleteIdWorkoutPlansNewIndexRoute
  '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute
  '/athletes/$athleteId/workout-plans/$workoutPlanId/edit': typeof protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof protectedRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordIndexRoute
  '/reset-password': typeof authResetPasswordIndexRoute
  '/sign-in': typeof authSignInIndexRoute
  '/allocation': typeof protectedAllocationIndexRoute
  '/athletes': typeof protectedAthletesIndexRoute
  '/challenges': typeof protectedChallengesIndexRoute
  '/dashboard': typeof protectedDashboardIndexRoute
  '/disciplines': typeof protectedDisciplinesIndexRoute
  '/exercises': typeof protectedExercisesIndexRoute
  '/management': typeof protectedManagementIndexRoute
  '/profile': typeof protectedProfileIndexRoute
  '/ranking': typeof protectedRankingIndexRoute
  '/rooms': typeof protectedRoomsIndexRoute
  '/schedules': typeof protectedSchedulesIndexRoute
  '/staff': typeof protectedStaffIndexRoute
  '/allocation/$eventId': typeof protectedAllocationEventIdIndexRoute
  '/athletes/$athleteId': typeof protectedAthletesAthleteIdIndexRoute
  '/athletes/new': typeof protectedAthletesNewIndexRoute
  '/management/dashboard': typeof protectedManagementDashboardIndexRoute
  '/management/disciplines': typeof protectedManagementDisciplinesIndexRoute
  '/management/exercises': typeof protectedManagementExercisesIndexRoute
  '/rooms/$roomId': typeof protectedRoomsRoomIdIndexRoute
  '/rooms/new': typeof protectedRoomsNewIndexRoute
  '/staff/$staffMemberId': typeof protectedStaffStaffMemberIdIndexRoute
  '/staff/new': typeof protectedStaffNewIndexRoute
  '/allocation/$eventId/edit': typeof protectedAllocationEventIdEditIndexRoute
  '/allocation/events/new': typeof protectedAllocationEventsNewIndexRoute
  '/athletes/$athleteId/edit': typeof protectedAthletesAthleteIdEditIndexRoute
  '/management/disciplines/$disciplineId': typeof protectedManagementDisciplinesDisciplineIdIndexRoute
  '/management/disciplines/new': typeof protectedManagementDisciplinesNewIndexRoute
  '/management/exercises/$exerciseId': typeof protectedManagementExercisesExerciseIdIndexRoute
  '/management/exercises/new': typeof protectedManagementExercisesNewIndexRoute
  '/schedules/$scheduleId/edit': typeof protectedSchedulesScheduleIdEditIndexRoute
  '/staff/$staffMemberId/edit': typeof protectedStaffStaffMemberIdEditIndexRoute
  '/athletes/$athleteId/workout-blocks/$workoutBlockId': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute
  '/athletes/$athleteId/workout-blocks/new': typeof protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute
  '/athletes/$athleteId/workout-plans/new': typeof protectedAthletesAthleteIdWorkoutPlansNewIndexRoute
  '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute
  '/athletes/$athleteId/workout-plans/$workoutPlanId/edit': typeof protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth)': typeof authRouteRouteWithChildren
  '/(protected)': typeof protectedRouteRouteWithChildren
  '/(protected)/management': typeof protectedManagementRouteRouteWithChildren
  '/(auth)/forgot-password/': typeof authForgotPasswordIndexRoute
  '/(auth)/reset-password/': typeof authResetPasswordIndexRoute
  '/(auth)/sign-in/': typeof authSignInIndexRoute
  '/(protected)/allocation/': typeof protectedAllocationIndexRoute
  '/(protected)/athletes/': typeof protectedAthletesIndexRoute
  '/(protected)/challenges/': typeof protectedChallengesIndexRoute
  '/(protected)/dashboard/': typeof protectedDashboardIndexRoute
  '/(protected)/disciplines/': typeof protectedDisciplinesIndexRoute
  '/(protected)/exercises/': typeof protectedExercisesIndexRoute
  '/(protected)/management/': typeof protectedManagementIndexRoute
  '/(protected)/profile/': typeof protectedProfileIndexRoute
  '/(protected)/ranking/': typeof protectedRankingIndexRoute
  '/(protected)/rooms/': typeof protectedRoomsIndexRoute
  '/(protected)/schedules/': typeof protectedSchedulesIndexRoute
  '/(protected)/staff/': typeof protectedStaffIndexRoute
  '/(protected)/allocation/$eventId/': typeof protectedAllocationEventIdIndexRoute
  '/(protected)/athletes/$athleteId/': typeof protectedAthletesAthleteIdIndexRoute
  '/(protected)/athletes/new/': typeof protectedAthletesNewIndexRoute
  '/(protected)/management/dashboard/': typeof protectedManagementDashboardIndexRoute
  '/(protected)/management/disciplines/': typeof protectedManagementDisciplinesIndexRoute
  '/(protected)/management/exercises/': typeof protectedManagementExercisesIndexRoute
  '/(protected)/rooms/$roomId/': typeof protectedRoomsRoomIdIndexRoute
  '/(protected)/rooms/new/': typeof protectedRoomsNewIndexRoute
  '/(protected)/staff/$staffMemberId/': typeof protectedStaffStaffMemberIdIndexRoute
  '/(protected)/staff/new/': typeof protectedStaffNewIndexRoute
  '/(protected)/allocation/$eventId/edit/': typeof protectedAllocationEventIdEditIndexRoute
  '/(protected)/allocation/events/new/': typeof protectedAllocationEventsNewIndexRoute
  '/(protected)/athletes/$athleteId/edit/': typeof protectedAthletesAthleteIdEditIndexRoute
  '/(protected)/management/disciplines/$disciplineId/': typeof protectedManagementDisciplinesDisciplineIdIndexRoute
  '/(protected)/management/disciplines/new/': typeof protectedManagementDisciplinesNewIndexRoute
  '/(protected)/management/exercises/$exerciseId/': typeof protectedManagementExercisesExerciseIdIndexRoute
  '/(protected)/management/exercises/new/': typeof protectedManagementExercisesNewIndexRoute
  '/(protected)/schedules/$scheduleId/edit/': typeof protectedSchedulesScheduleIdEditIndexRoute
  '/(protected)/staff/$staffMemberId/edit/': typeof protectedStaffStaffMemberIdEditIndexRoute
  '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute
  '/(protected)/athletes/$athleteId/workout-blocks/new/': typeof protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute
  '/(protected)/athletes/$athleteId/workout-plans/new/': typeof protectedAthletesAthleteIdWorkoutPlansNewIndexRoute
  '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/': typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute
  '/(protected)/athletes/$athleteId/workout-plans/$workoutPlanId/edit/': typeof protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/management'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/allocation'
    | '/athletes'
    | '/challenges'
    | '/dashboard'
    | '/disciplines'
    | '/exercises'
    | '/management/'
    | '/profile'
    | '/ranking'
    | '/rooms'
    | '/schedules'
    | '/staff'
    | '/allocation/$eventId'
    | '/athletes/$athleteId'
    | '/athletes/new'
    | '/management/dashboard'
    | '/management/disciplines'
    | '/management/exercises'
    | '/rooms/$roomId'
    | '/rooms/new'
    | '/staff/$staffMemberId'
    | '/staff/new'
    | '/allocation/$eventId/edit'
    | '/allocation/events/new'
    | '/athletes/$athleteId/edit'
    | '/management/disciplines/$disciplineId'
    | '/management/disciplines/new'
    | '/management/exercises/$exerciseId'
    | '/management/exercises/new'
    | '/schedules/$scheduleId/edit'
    | '/staff/$staffMemberId/edit'
    | '/athletes/$athleteId/workout-blocks/$workoutBlockId'
    | '/athletes/$athleteId/workout-blocks/new'
    | '/athletes/$athleteId/workout-plans/new'
    | '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit'
    | '/athletes/$athleteId/workout-plans/$workoutPlanId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/allocation'
    | '/athletes'
    | '/challenges'
    | '/dashboard'
    | '/disciplines'
    | '/exercises'
    | '/management'
    | '/profile'
    | '/ranking'
    | '/rooms'
    | '/schedules'
    | '/staff'
    | '/allocation/$eventId'
    | '/athletes/$athleteId'
    | '/athletes/new'
    | '/management/dashboard'
    | '/management/disciplines'
    | '/management/exercises'
    | '/rooms/$roomId'
    | '/rooms/new'
    | '/staff/$staffMemberId'
    | '/staff/new'
    | '/allocation/$eventId/edit'
    | '/allocation/events/new'
    | '/athletes/$athleteId/edit'
    | '/management/disciplines/$disciplineId'
    | '/management/disciplines/new'
    | '/management/exercises/$exerciseId'
    | '/management/exercises/new'
    | '/schedules/$scheduleId/edit'
    | '/staff/$staffMemberId/edit'
    | '/athletes/$athleteId/workout-blocks/$workoutBlockId'
    | '/athletes/$athleteId/workout-blocks/new'
    | '/athletes/$athleteId/workout-plans/new'
    | '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit'
    | '/athletes/$athleteId/workout-plans/$workoutPlanId/edit'
  id:
    | '__root__'
    | '/'
    | '/(auth)'
    | '/(protected)'
    | '/(protected)/management'
    | '/(auth)/forgot-password/'
    | '/(auth)/reset-password/'
    | '/(auth)/sign-in/'
    | '/(protected)/allocation/'
    | '/(protected)/athletes/'
    | '/(protected)/challenges/'
    | '/(protected)/dashboard/'
    | '/(protected)/disciplines/'
    | '/(protected)/exercises/'
    | '/(protected)/management/'
    | '/(protected)/profile/'
    | '/(protected)/ranking/'
    | '/(protected)/rooms/'
    | '/(protected)/schedules/'
    | '/(protected)/staff/'
    | '/(protected)/allocation/$eventId/'
    | '/(protected)/athletes/$athleteId/'
    | '/(protected)/athletes/new/'
    | '/(protected)/management/dashboard/'
    | '/(protected)/management/disciplines/'
    | '/(protected)/management/exercises/'
    | '/(protected)/rooms/$roomId/'
    | '/(protected)/rooms/new/'
    | '/(protected)/staff/$staffMemberId/'
    | '/(protected)/staff/new/'
    | '/(protected)/allocation/$eventId/edit/'
    | '/(protected)/allocation/events/new/'
    | '/(protected)/athletes/$athleteId/edit/'
    | '/(protected)/management/disciplines/$disciplineId/'
    | '/(protected)/management/disciplines/new/'
    | '/(protected)/management/exercises/$exerciseId/'
    | '/(protected)/management/exercises/new/'
    | '/(protected)/schedules/$scheduleId/edit/'
    | '/(protected)/staff/$staffMemberId/edit/'
    | '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/'
    | '/(protected)/athletes/$athleteId/workout-blocks/new/'
    | '/(protected)/athletes/$athleteId/workout-plans/new/'
    | '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/'
    | '/(protected)/athletes/$athleteId/workout-plans/$workoutPlanId/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authRouteRoute: typeof authRouteRouteWithChildren
  protectedRouteRoute: typeof protectedRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(protected)': {
      id: '/(protected)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof protectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/management': {
      id: '/(protected)/management'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof protectedManagementRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/staff/': {
      id: '/(protected)/staff/'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof protectedStaffIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/schedules/': {
      id: '/(protected)/schedules/'
      path: '/schedules'
      fullPath: '/schedules'
      preLoaderRoute: typeof protectedSchedulesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/rooms/': {
      id: '/(protected)/rooms/'
      path: '/rooms'
      fullPath: '/rooms'
      preLoaderRoute: typeof protectedRoomsIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/ranking/': {
      id: '/(protected)/ranking/'
      path: '/ranking'
      fullPath: '/ranking'
      preLoaderRoute: typeof protectedRankingIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/profile/': {
      id: '/(protected)/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof protectedProfileIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/management/': {
      id: '/(protected)/management/'
      path: '/'
      fullPath: '/management/'
      preLoaderRoute: typeof protectedManagementIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/exercises/': {
      id: '/(protected)/exercises/'
      path: '/exercises'
      fullPath: '/exercises'
      preLoaderRoute: typeof protectedExercisesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/disciplines/': {
      id: '/(protected)/disciplines/'
      path: '/disciplines'
      fullPath: '/disciplines'
      preLoaderRoute: typeof protectedDisciplinesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/dashboard/': {
      id: '/(protected)/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof protectedDashboardIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/challenges/': {
      id: '/(protected)/challenges/'
      path: '/challenges'
      fullPath: '/challenges'
      preLoaderRoute: typeof protectedChallengesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/': {
      id: '/(protected)/athletes/'
      path: '/athletes'
      fullPath: '/athletes'
      preLoaderRoute: typeof protectedAthletesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/allocation/': {
      id: '/(protected)/allocation/'
      path: '/allocation'
      fullPath: '/allocation'
      preLoaderRoute: typeof protectedAllocationIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(auth)/sign-in/': {
      id: '/(auth)/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/reset-password/': {
      id: '/(auth)/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/forgot-password/': {
      id: '/(auth)/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(protected)/staff/new/': {
      id: '/(protected)/staff/new/'
      path: '/staff/new'
      fullPath: '/staff/new'
      preLoaderRoute: typeof protectedStaffNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/staff/$staffMemberId/': {
      id: '/(protected)/staff/$staffMemberId/'
      path: '/staff/$staffMemberId'
      fullPath: '/staff/$staffMemberId'
      preLoaderRoute: typeof protectedStaffStaffMemberIdIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/rooms/new/': {
      id: '/(protected)/rooms/new/'
      path: '/rooms/new'
      fullPath: '/rooms/new'
      preLoaderRoute: typeof protectedRoomsNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/rooms/$roomId/': {
      id: '/(protected)/rooms/$roomId/'
      path: '/rooms/$roomId'
      fullPath: '/rooms/$roomId'
      preLoaderRoute: typeof protectedRoomsRoomIdIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/management/exercises/': {
      id: '/(protected)/management/exercises/'
      path: '/exercises'
      fullPath: '/management/exercises'
      preLoaderRoute: typeof protectedManagementExercisesIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/management/disciplines/': {
      id: '/(protected)/management/disciplines/'
      path: '/disciplines'
      fullPath: '/management/disciplines'
      preLoaderRoute: typeof protectedManagementDisciplinesIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/management/dashboard/': {
      id: '/(protected)/management/dashboard/'
      path: '/dashboard'
      fullPath: '/management/dashboard'
      preLoaderRoute: typeof protectedManagementDashboardIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/athletes/new/': {
      id: '/(protected)/athletes/new/'
      path: '/athletes/new'
      fullPath: '/athletes/new'
      preLoaderRoute: typeof protectedAthletesNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/': {
      id: '/(protected)/athletes/$athleteId/'
      path: '/athletes/$athleteId'
      fullPath: '/athletes/$athleteId'
      preLoaderRoute: typeof protectedAthletesAthleteIdIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/allocation/$eventId/': {
      id: '/(protected)/allocation/$eventId/'
      path: '/allocation/$eventId'
      fullPath: '/allocation/$eventId'
      preLoaderRoute: typeof protectedAllocationEventIdIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/staff/$staffMemberId/edit/': {
      id: '/(protected)/staff/$staffMemberId/edit/'
      path: '/staff/$staffMemberId/edit'
      fullPath: '/staff/$staffMemberId/edit'
      preLoaderRoute: typeof protectedStaffStaffMemberIdEditIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/schedules/$scheduleId/edit/': {
      id: '/(protected)/schedules/$scheduleId/edit/'
      path: '/schedules/$scheduleId/edit'
      fullPath: '/schedules/$scheduleId/edit'
      preLoaderRoute: typeof protectedSchedulesScheduleIdEditIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/management/exercises/new/': {
      id: '/(protected)/management/exercises/new/'
      path: '/exercises/new'
      fullPath: '/management/exercises/new'
      preLoaderRoute: typeof protectedManagementExercisesNewIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/management/exercises/$exerciseId/': {
      id: '/(protected)/management/exercises/$exerciseId/'
      path: '/exercises/$exerciseId'
      fullPath: '/management/exercises/$exerciseId'
      preLoaderRoute: typeof protectedManagementExercisesExerciseIdIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/management/disciplines/new/': {
      id: '/(protected)/management/disciplines/new/'
      path: '/disciplines/new'
      fullPath: '/management/disciplines/new'
      preLoaderRoute: typeof protectedManagementDisciplinesNewIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/management/disciplines/$disciplineId/': {
      id: '/(protected)/management/disciplines/$disciplineId/'
      path: '/disciplines/$disciplineId'
      fullPath: '/management/disciplines/$disciplineId'
      preLoaderRoute: typeof protectedManagementDisciplinesDisciplineIdIndexRouteImport
      parentRoute: typeof protectedManagementRouteRoute
    }
    '/(protected)/athletes/$athleteId/edit/': {
      id: '/(protected)/athletes/$athleteId/edit/'
      path: '/athletes/$athleteId/edit'
      fullPath: '/athletes/$athleteId/edit'
      preLoaderRoute: typeof protectedAthletesAthleteIdEditIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/allocation/events/new/': {
      id: '/(protected)/allocation/events/new/'
      path: '/allocation/events/new'
      fullPath: '/allocation/events/new'
      preLoaderRoute: typeof protectedAllocationEventsNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/allocation/$eventId/edit/': {
      id: '/(protected)/allocation/$eventId/edit/'
      path: '/allocation/$eventId/edit'
      fullPath: '/allocation/$eventId/edit'
      preLoaderRoute: typeof protectedAllocationEventIdEditIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/workout-plans/new/': {
      id: '/(protected)/athletes/$athleteId/workout-plans/new/'
      path: '/athletes/$athleteId/workout-plans/new'
      fullPath: '/athletes/$athleteId/workout-plans/new'
      preLoaderRoute: typeof protectedAthletesAthleteIdWorkoutPlansNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/workout-blocks/new/': {
      id: '/(protected)/athletes/$athleteId/workout-blocks/new/'
      path: '/athletes/$athleteId/workout-blocks/new'
      fullPath: '/athletes/$athleteId/workout-blocks/new'
      preLoaderRoute: typeof protectedAthletesAthleteIdWorkoutBlocksNewIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/': {
      id: '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/'
      path: '/athletes/$athleteId/workout-blocks/$workoutBlockId'
      fullPath: '/athletes/$athleteId/workout-blocks/$workoutBlockId'
      preLoaderRoute: typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/workout-plans/$workoutPlanId/edit/': {
      id: '/(protected)/athletes/$athleteId/workout-plans/$workoutPlanId/edit/'
      path: '/athletes/$athleteId/workout-plans/$workoutPlanId/edit'
      fullPath: '/athletes/$athleteId/workout-plans/$workoutPlanId/edit'
      preLoaderRoute: typeof protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/': {
      id: '/(protected)/athletes/$athleteId/workout-blocks/$workoutBlockId/edit/'
      path: '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit'
      fullPath: '/athletes/$athleteId/workout-blocks/$workoutBlockId/edit'
      preLoaderRoute: typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authForgotPasswordIndexRoute: typeof authForgotPasswordIndexRoute
  authResetPasswordIndexRoute: typeof authResetPasswordIndexRoute
  authSignInIndexRoute: typeof authSignInIndexRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authForgotPasswordIndexRoute: authForgotPasswordIndexRoute,
  authResetPasswordIndexRoute: authResetPasswordIndexRoute,
  authSignInIndexRoute: authSignInIndexRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface protectedManagementRouteRouteChildren {
  protectedManagementIndexRoute: typeof protectedManagementIndexRoute
  protectedManagementDashboardIndexRoute: typeof protectedManagementDashboardIndexRoute
  protectedManagementDisciplinesIndexRoute: typeof protectedManagementDisciplinesIndexRoute
  protectedManagementExercisesIndexRoute: typeof protectedManagementExercisesIndexRoute
  protectedManagementDisciplinesDisciplineIdIndexRoute: typeof protectedManagementDisciplinesDisciplineIdIndexRoute
  protectedManagementDisciplinesNewIndexRoute: typeof protectedManagementDisciplinesNewIndexRoute
  protectedManagementExercisesExerciseIdIndexRoute: typeof protectedManagementExercisesExerciseIdIndexRoute
  protectedManagementExercisesNewIndexRoute: typeof protectedManagementExercisesNewIndexRoute
}

const protectedManagementRouteRouteChildren: protectedManagementRouteRouteChildren =
  {
    protectedManagementIndexRoute: protectedManagementIndexRoute,
    protectedManagementDashboardIndexRoute:
      protectedManagementDashboardIndexRoute,
    protectedManagementDisciplinesIndexRoute:
      protectedManagementDisciplinesIndexRoute,
    protectedManagementExercisesIndexRoute:
      protectedManagementExercisesIndexRoute,
    protectedManagementDisciplinesDisciplineIdIndexRoute:
      protectedManagementDisciplinesDisciplineIdIndexRoute,
    protectedManagementDisciplinesNewIndexRoute:
      protectedManagementDisciplinesNewIndexRoute,
    protectedManagementExercisesExerciseIdIndexRoute:
      protectedManagementExercisesExerciseIdIndexRoute,
    protectedManagementExercisesNewIndexRoute:
      protectedManagementExercisesNewIndexRoute,
  }

const protectedManagementRouteRouteWithChildren =
  protectedManagementRouteRoute._addFileChildren(
    protectedManagementRouteRouteChildren,
  )

interface protectedRouteRouteChildren {
  protectedManagementRouteRoute: typeof protectedManagementRouteRouteWithChildren
  protectedAllocationIndexRoute: typeof protectedAllocationIndexRoute
  protectedAthletesIndexRoute: typeof protectedAthletesIndexRoute
  protectedChallengesIndexRoute: typeof protectedChallengesIndexRoute
  protectedDashboardIndexRoute: typeof protectedDashboardIndexRoute
  protectedDisciplinesIndexRoute: typeof protectedDisciplinesIndexRoute
  protectedExercisesIndexRoute: typeof protectedExercisesIndexRoute
  protectedProfileIndexRoute: typeof protectedProfileIndexRoute
  protectedRankingIndexRoute: typeof protectedRankingIndexRoute
  protectedRoomsIndexRoute: typeof protectedRoomsIndexRoute
  protectedSchedulesIndexRoute: typeof protectedSchedulesIndexRoute
  protectedStaffIndexRoute: typeof protectedStaffIndexRoute
  protectedAllocationEventIdIndexRoute: typeof protectedAllocationEventIdIndexRoute
  protectedAthletesAthleteIdIndexRoute: typeof protectedAthletesAthleteIdIndexRoute
  protectedAthletesNewIndexRoute: typeof protectedAthletesNewIndexRoute
  protectedRoomsRoomIdIndexRoute: typeof protectedRoomsRoomIdIndexRoute
  protectedRoomsNewIndexRoute: typeof protectedRoomsNewIndexRoute
  protectedStaffStaffMemberIdIndexRoute: typeof protectedStaffStaffMemberIdIndexRoute
  protectedStaffNewIndexRoute: typeof protectedStaffNewIndexRoute
  protectedAllocationEventIdEditIndexRoute: typeof protectedAllocationEventIdEditIndexRoute
  protectedAllocationEventsNewIndexRoute: typeof protectedAllocationEventsNewIndexRoute
  protectedAthletesAthleteIdEditIndexRoute: typeof protectedAthletesAthleteIdEditIndexRoute
  protectedSchedulesScheduleIdEditIndexRoute: typeof protectedSchedulesScheduleIdEditIndexRoute
  protectedStaffStaffMemberIdEditIndexRoute: typeof protectedStaffStaffMemberIdEditIndexRoute
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute: typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute
  protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute: typeof protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute
  protectedAthletesAthleteIdWorkoutPlansNewIndexRoute: typeof protectedAthletesAthleteIdWorkoutPlansNewIndexRoute
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute: typeof protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute
  protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute: typeof protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute
}

const protectedRouteRouteChildren: protectedRouteRouteChildren = {
  protectedManagementRouteRoute: protectedManagementRouteRouteWithChildren,
  protectedAllocationIndexRoute: protectedAllocationIndexRoute,
  protectedAthletesIndexRoute: protectedAthletesIndexRoute,
  protectedChallengesIndexRoute: protectedChallengesIndexRoute,
  protectedDashboardIndexRoute: protectedDashboardIndexRoute,
  protectedDisciplinesIndexRoute: protectedDisciplinesIndexRoute,
  protectedExercisesIndexRoute: protectedExercisesIndexRoute,
  protectedProfileIndexRoute: protectedProfileIndexRoute,
  protectedRankingIndexRoute: protectedRankingIndexRoute,
  protectedRoomsIndexRoute: protectedRoomsIndexRoute,
  protectedSchedulesIndexRoute: protectedSchedulesIndexRoute,
  protectedStaffIndexRoute: protectedStaffIndexRoute,
  protectedAllocationEventIdIndexRoute: protectedAllocationEventIdIndexRoute,
  protectedAthletesAthleteIdIndexRoute: protectedAthletesAthleteIdIndexRoute,
  protectedAthletesNewIndexRoute: protectedAthletesNewIndexRoute,
  protectedRoomsRoomIdIndexRoute: protectedRoomsRoomIdIndexRoute,
  protectedRoomsNewIndexRoute: protectedRoomsNewIndexRoute,
  protectedStaffStaffMemberIdIndexRoute: protectedStaffStaffMemberIdIndexRoute,
  protectedStaffNewIndexRoute: protectedStaffNewIndexRoute,
  protectedAllocationEventIdEditIndexRoute:
    protectedAllocationEventIdEditIndexRoute,
  protectedAllocationEventsNewIndexRoute:
    protectedAllocationEventsNewIndexRoute,
  protectedAthletesAthleteIdEditIndexRoute:
    protectedAthletesAthleteIdEditIndexRoute,
  protectedSchedulesScheduleIdEditIndexRoute:
    protectedSchedulesScheduleIdEditIndexRoute,
  protectedStaffStaffMemberIdEditIndexRoute:
    protectedStaffStaffMemberIdEditIndexRoute,
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute:
    protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdIndexRoute,
  protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute:
    protectedAthletesAthleteIdWorkoutBlocksNewIndexRoute,
  protectedAthletesAthleteIdWorkoutPlansNewIndexRoute:
    protectedAthletesAthleteIdWorkoutPlansNewIndexRoute,
  protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute:
    protectedAthletesAthleteIdWorkoutBlocksWorkoutBlockIdEditIndexRoute,
  protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute:
    protectedAthletesAthleteIdWorkoutPlansWorkoutPlanIdEditIndexRoute,
}

const protectedRouteRouteWithChildren = protectedRouteRoute._addFileChildren(
  protectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authRouteRoute: authRouteRouteWithChildren,
  protectedRouteRoute: protectedRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
